import {
  ToolPlayControllerFrameBar,
  ToolPlayControllerFrameTrackSlider,
} from '@/component/Tool';
import { VFlex, useUnleash } from '@/package';

const TaskLayoutFooterPlaybar = () => {
  const { isEnabled } = useUnleash();

  return (
    <VFlex className="h-full w-full overflow-x-auto overflow-y-hidden px-0.5 py-1 text-body-sm">
      {isEnabled('vuex.sapporo.enabledTrackIDManager') ? (
        <ToolPlayControllerFrameTrackSlider />
      ) : (
        <ToolPlayControllerFrameBar />
      )}
    </VFlex>
  );
};

export default TaskLayoutFooterPlaybar;
